import useApi from '~/composables/useApi';
import { Accessory, AccessoryGroup, AccessoryFilterInput } from './types';
import accessories from './accessories.gql';
import accessoryGroups from './accessoryGroups.gql';
import {
	useContext,
	ref,
} from '@nuxtjs/composition-api';

interface AccessoryOutput {
    items: Array<Accessory>,
}

export interface AccessoryGroupOutput {
    items: Array<AccessoryGroup>,
	pageSize: number
}

export const useAccessory = () => {
	const { query } = useApi();
	const loadingAccessories = ref(false);
    
	const getAccessoryGroups = async (productSku: string): Promise<AccessoryGroupOutput|null> => {
		loadingAccessories.value = true;
		const filter = {
			product_id: productSku,
		};

		const { data } = await query<{ accessoryGroups: AccessoryGroupOutput }>(accessoryGroups, { filter });
		const items = data?.accessoryGroups?.items ?? [];
		loadingAccessories.value = false;
        
		return items.length > 0 ? { items: items, pageSize: items.length } : null;
	};

	return {
		getAccessoryGroups,
		loadingAccessories,
	};
}

export default useAccessory;
